import React from 'react';
import PropTypes from 'prop-types';

import { StarRating } from 'components/review/StarRating';
import { Text } from 'components/core/Typography';
import { Link } from 'components/core/Link';

import './FacilityRating.scss';

export function FacilityRating({
	average,
	facilityName,
	numberOfRatings,
	reviewsUrl,
	renderLabel = ({ reviewsUrl, numberOfRatings }) => (
		<Link
			href={reviewsUrl}
			secondary
			className="review-count"
		>
			based on <span itemProp="reviewCount">{numberOfRatings}</span>{' '}
			reviews
		</Link>
	),
	...props
}) {
	return (
		<div
			className="facility-rating"
			itemProp="aggregateRating"
			itemScope
			itemType="https://schema.org/AggregateRating"
		>
			<StarRating rating={average} />
			<span
				className="hidden"
				itemProp="worstRating"
			>
				0
			</span>
			<Text
				className="rating-details"
				last
			>
				<span className="rating">
					<span itemProp="ratingValue">{average}</span> out of{' '}
					<span itemProp="bestRating">5</span> {'- '}
				</span>
				{renderLabel({ reviewsUrl, numberOfRatings, ...props })}
			</Text>
			{!!facilityName && (
				<span
					itemProp="itemReviewed"
					itemScope
					itemType="https://schema.org/Thing"
					className="visually-hidden"
				>
					<span itemProp="name">{facilityName}</span>
				</span>
			)}
		</div>
	);
}

FacilityRating.propTypes = {
	average: PropTypes.number.isRequired,
	facilityName: PropTypes.string,
	numberOfRatings: PropTypes.number.isRequired,
	reviewsUrl: PropTypes.string.isRequired,
	renderLabel: PropTypes.func,
};

export default React.memo(FacilityRating);
